<div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="border-div height-one">
            <div class="floatinghead clearfix">
                <h2 class="mainhead mainhead-xs"><span class="text">Time remaining</span></h2>
                
            </div>
            <ul class="timeperiod" *ngIf="exchangeInfo['Sold_ProjectedSaleDate']">
                <li><p>Trade Start<span class="value">{{tradeStartDate|date:'MM/dd/yyyy'}}</span><span class="days"></span></p></li>
                <li><p>Trade End<span class="value">{{tradeEndDate|date:'MM/dd/yyyy'}}</span><span class="days"></span></p></li>
                <li><p>ID Period <span class="value">{{IdPeriodDays}}</span><span class="days">Days</span></p></li>
                <li><p>HC Period <span class="value">{{ClosingPeriodDays}}</span><span class="days">Days</span></p></li>
            </ul>
            <div class="row">
                <div class="row10">
                    <div class="col-md-12">
                        <div id="divchart" #chartContainer style="max-height:400px;"></div>
                    </div>
                </div>
            </div>
            <ul class="steps" *ngIf="chartDataResponse?.length > 0">
                <li><span>LOI</span>Offer Negotiation</li>
                <li><span>PSA</span>PSA Negotiation</li>
                <li><span>DD</span>Due Diligence</li>
                <li><span>HC</span>Hard Contract</li>
            </ul>
            <div *ngIf="!exchangeInfo['Sold_ProjectedSaleDate']" class="nodata">
                <i class="fa fa-exclamation-triangle icon"></i>
                <p>No Data Available</p>
            </div>
            <div class="text-right" *ngIf="chartDataResponse?.length > 0">
                <a (click)="onViewOffers()" class="bluelinkunderline">View Deals</a>
            </div>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
        <div class="border-div height-one">
            <div class="floatinghead clearfix">
                <h2 class="mainhead mainhead-xs"><span class="text">My Task List</span></h2>

            </div>
            <ul class="task-label">
                <li><span style="background:#D1D1D1"></span>Upcoming : {{taskHeaders ? taskHeaders[2].Count:0}}</li>
                <li><span style="background:#EC5555"></span>Overdue : {{taskHeaders ? taskHeaders[1].Count:0}}</li>
                <!--<li><span style="background:#5BC7AF"></span>Completed : {{taskHeaders ? taskHeaders[0].Count:0}}</li>-->
            </ul>
            <div style="max-height:250px;overflow-y:scroll">
                <ul class="offerk-list">
                    <li *ngFor="let task of TaskSummary">
                        <span>
                            <label class="custom-checkbox withoutlabel" (change)="changeOfferStatus(task.TaskId);">
                                <input type="checkbox" [checked]="task.Status=='3'" [disabled]="task.Status=='3' || IsConnectedExchange">
                                <i></i>
                            </label>
                        </span>
                          <a href="javascript:void(0);" routerLink="/offer-detail/{{task.LeadGUID}}" [queryParams]="{prevroute:'1031 Exchange',link:router.url}" target="_blank"><h4 style="color: #337ab7">{{task.Name}} - {{task.Deal}}</h4></a>
                        <h5>{{task.StartDate| date:'dd MMM yyyy'}} - {{task.EndDate| date:'dd MMM yyyy'}} <strong [ngStyle]="{ 'color': task.Status=='1' ? '#EC5555' : task.Status=='2' ? '#D1D1D1' :'#5BC7AF' }">{{task.Status =='1'?'Overdue':task.Status =='2'?'Upcoming':'Completed'}}</strong> </h5>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
        <div class="border-div height-one" *ngIf="exchangeInfo">
            <h2 class="mainhead "><span class="text">Interest Criteria</span></h2>
            <h3 class="bluelabel margin-bottom-5">Trader Information</h3>
            <ul class="interesttags margin-bottom-15">
                <li>{{exchangeInfo.Sold_ProjectedSaleDate ? (Validation.convertUTCDateToLocalDate(exchangeInfo.Sold_ProjectedSaleDate)| date:'MM/dd/yyyy') :'-'}} </li>
                <li *ngIf="exchangeInfo.TotalSalePrice">$ {{exchangeInfo.TotalSalePrice|number}}</li>
            </ul>
            <h3 class="bluelabel margin-bottom-5">1031 Trade Criteria</h3>
            <p *ngIf="(!exchangeInfo.GeographyTypes) && (!exchangeInfo.PropertyTypes) && (!exchangeInfo.StrategyText)">-</p>
            <ul class="interesttags margin-bottom-15">
                <li *ngIf="exchangeInfo.GeographyTypes">{{exchangeInfo.GeographyTypes}}</li>
                <li *ngIf="exchangeInfo.PropertyTypes">{{exchangeInfo.PropertyTypes}}</li>
                <li *ngIf="exchangeInfo.StrategyText">{{exchangeInfo.StrategyText}}</li>
            </ul>
            <div class="text-right">
                <a routerLink="/1031-registration/{{exchangeGuid}}" [queryParams]="{prevroute:'1031 Trade',link:router.url,compaignPage:'true'}" class="bluelinkunderline">Modify</a>
            </div>
        </div>
    </div>
</div>
